module.exports = __webpack_public_path__ + "c5650951351d0925b0a20a5e6312a1a7.svg";